import React from "react";
import { useParams } from "react-router-dom";
import { observer, inject } from "mobx-react";
import { useQuery } from "@apollo/client";
import { SITEMAP } from "Services/queries";
import useDefaultParams from "Services/useDefaultParams";
import { pipe } from "Utils";
import { HeaderTextSeo } from "ComponentsUI/SeoBlock";
import { SitemapLink } from "ComponentsUIV2/Links";
import { Bull } from "ComponentsUIV2/Dividers";

const SitemapContainer = (props) => {
	const { seoBlock } = props;
	const routeParams = useParams();
	const { regionUrl } = useDefaultParams(routeParams);

	const { data, loading } = useQuery(SITEMAP, {
		skip: !regionUrl,
		variables: { region_url: regionUrl },
	});

	if (loading || !data?.sitemap?.length) {
		return null;
	}
	const sitemap = data.sitemap;

	return (
		<>
			<HeaderTextSeo header={seoBlock?.seoHeader} text={seoBlock?.seoText} />
			{sitemap.map((site) => {
				return (
					<React.Fragment key={site.url}>
						<SitemapLink text={site.h1} src={site.url} />
						<Bull />
					</React.Fragment>
				);
			})}
		</>
	);
};

export default pipe(observer, inject("ApplicationModel"))(SitemapContainer);
